<body>
    <div class="image-container"> 
    <img src="./assets/images/onBoardingErrorScreen.jpg" alt="Image" class="fit-to-screen">
    </div>
   <!-- <div class="button-container">
        <button class="submit-button rounded-pill" (click)="onClose()">CLOSE</button>
      </div> -->
  </body>


